export default __webpack_public_path__ + "static/media/m-card-desc.33f2c296.png";